import { Unit } from "types/landlord/address";
import { CurrentTenantsSection } from "views/properties-id/components/CurrentTenantsSection";
import { ListingSection } from "./ListingSection";
import { GeneralSection } from "./GeneralSection";
import { ListingAppearanceSection } from "./ListingAppearanceSection";
import { LockboxSection } from "./LockboxSection";
import { PlanSection } from "./PlanSection";
import { AmenitiesSection } from "./AmenitiesSection";
import { MarketingInfoSection } from "./MarketingInfoSection";
import { PhotosSection } from "./PhotosSection";
import { Show } from "shared/components";
import { RentalInfoSection } from "shared/app/RentalInfoSection";
import { useAuthContext } from "providers/Auth";

interface UnitDetailsProps {
  unit?: Unit;
}

export const UnitDetails = ({ unit }: UnitDetailsProps) => {
  const { type } = useAuthContext();

  if (!unit) return null;

  return (
    <div>
      <div className="space-y-4 max-w-[822px] w-full">
        <ListingSection
          propertyKind={unit.property.kind}
          propertyId={unit.property.id}
          unit={unit}
        />
        <Show if={type.isBoomCRM}>
          <ListingAppearanceSection unit={unit} />
        </Show>
        <GeneralSection unit={unit} />
        {unit.property.prescreening_template?.showing_type ===
          "self_guided" && (
          <LockboxSection
            unit={unit}
            propertyId={unit.property.id}
            propertyTimezone={unit.property.timezone}
          />
        )}
        <RentalInfoSection unit={unit} />
        <Show if={unit.property.kind || type.isPmsListingSyncEnabled}>
          <PlanSection unit={unit} />
        </Show>
        <CurrentTenantsSection
          propertyId={unit.property.id}
          unitId={unit.id}
          initialTenants={unit.tenant_contacts}
        />
        <Show if={unit.property.kind || type.isPmsListingSyncEnabled}>
          <AmenitiesSection unit={unit} />
          <MarketingInfoSection unit={unit} />
          <PhotosSection unit={unit} />
        </Show>
      </div>
    </div>
  );
};
